import React, {useState} from "react";
import App from '../App';

/***********************************************************
 *  Constantes *
 * **********************************************************/
const body = document.querySelector('body');



/***********************************************************
 *  Variables *
 * **********************************************************/
let var_fob;
let var_flete;
let var_arancel;
let var_subtotal;
let adicionales_checked = false;
let var_adicionales = '0';
let operativos_checked = false;
let var_operativos = '0';
let var_aseguradoTotal;
let var_tarifa;
let var_primaMinima;

/***********************************************************
 *  Funciones *
 * **********************************************************/

const formatterDolar = new Intl.NumberFormat('en-US', {
    //   style: 'currency',
    //   currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

function separador_deMiles(number) {
    let value = number.toString();
    
     //Funcion para agregar separador de miles
     var contador = 0,
         separadorDecimal = false,
         valueTemp = "",
         valueFinal = "";

     //Verifico si el value posee un separador de decimales
     for (var i = value.length; i >= 0; i--) {
         if (value.charAt(i) == '.')
             separadorDecimal = true;
     }
     //Ciclo para recorrer la cadena y colocar los separadores de miles
     for (var i = value.length - 1; i >= 0; i--) {
         //Agrego el caracter
         valueTemp += value.charAt(i);

         if (separadorDecimal == true) {
             //Condicional para saber cuando paso el separador de decimal
             if (value.charAt(i) == '.')
                 separadorDecimal = false;
         } else {
             //Si ya paso el separador de decimal, comienzo el conteo para los separadores de Miles
             contador += 1;
             //cuando el contador llegue a 3 coloco un separador de miles
             if (contador == 3 && i != 0) {
                 valueTemp += ',';
                 contador = 0;
             }
         }
     }
     //Ciclo para reordenar correctamente la cadena de value
     for (var i = valueTemp.length; i >= 0; i--) {
         valueFinal += valueTemp.charAt(i);
     }
     return valueFinal;
};

function toNumeric (value){
    if(value === ''){
        value = 0;
    }
    return parseFloat(value);
}

function addInvalid (node, boolean){
    if(node){
        if(boolean){
            if(!node.classList.contains('invalid')){
                node.classList.add('invalid');
            }
        }else{
            if(node.classList.contains('invalid')){
                node.classList.remove('invalid');
            }
        }
    }
}

function validateField(inputValue) {
    let valueesPermitidos = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, '.'];
    try {
        //Funcion para Validar que los campos contengan solo valuees Numericos
            let permitido = "",
            contadorDecimal = 0;
        for (var i = 0; i <= inputValue.length; i++) {
            for (var j = 0; j < valueesPermitidos.length; j++) {
                //Valido que el caracter seleccionado se encuentre dentro de los valuees permitidos
                if (inputValue.charAt(i) == valueesPermitidos[j]) {
                    if (inputValue.charAt(i) != '.') {
                        //Si es distinto de un separador de decimales agrego el caracter
                        permitido += inputValue.charAt(i);
                    } else if (inputValue.charAt(i) == '.' & contadorDecimal < 1) {
                        //Si es un separador de decimales, verifico que no se repita
                        permitido += inputValue.charAt(i);
                        contadorDecimal += 1;
                    }
                }
            }
        }
        if (permitido == '') {
            return '';
        }
        return permitido;
    } catch {}
};


function getCheckInputValue (id, isChecked, currentValue = ''){
     let checkInputlResult = document.querySelector('#'+id);
     let result = '';
     if (isChecked) {
        //Si es para los Adicionales
        if(id === 'additional_result'){
            // Gastos Adicionales (10%) = Subtotal * 0,1
            if(currentValue === ''){
                result = document.querySelector('#subtotal_result').innerHTML;
                //Removemos los caracteres que no sean numeros
                result = validateField(result);
                //Calculamos Gastos Adicionales (10%) = Subtotal * 0,1
                result = toNumeric(result) * 0.1;
                // Formateamos y actualizamos
                checkInputlResult.innerHTML = formatterDolar.format(result);
    
            }else{
                result = toNumeric(currentValue) * 0.1;
                checkInputlResult.innerHTML = formatterDolar.format(result);
            }

        }else if(id === 'operatives_result'){
              // Gastos Operativos (10%) = Valor FOB * 0,1
            if(currentValue === ''){
                result = document.querySelector('#fob_value').value;
                //Removemos los caracteres que no sean numeros
                result = validateField(result);
                //Calculamos Gastos Operativos (10%) = Valor FOB * 0,1
                result = toNumeric(result) * 0.1;
                // Formateamos y actualizamos
                checkInputlResult.innerHTML = formatterDolar.format(result);
            } else {
                result = toNumeric(currentValue) * 0.1;
                checkInputlResult.innerHTML = formatterDolar.format(result);
            }
        }

        return result;
     
    } else {
        checkInputlResult.innerHTML = '0';
    }
    return 0;
}

//Funcion para Obtener los valores introducidos en los campos
function getValues(fieldInputs) {
    //Valido que el valor Fob y la Tarifa no sean nulos
    fieldInputs.map(el => {
        if(el.id === 'fob_value'){
            var_fob = validateField(el.value);
            var_fob = toNumeric(var_fob);
        }else if(el.id === 'flete_value'){
            var_flete = validateField(el.value);
            var_flete = toNumeric(var_flete);
        }else if(el.id === 'tax_value'){
            var_arancel = validateField(el.value);
            var_arancel = toNumeric(var_arancel);
        }else if(el.id === 'additionalCheck'){
            adicionales_checked = el.active;
        }else if(el.id === 'operativesCheck'){
            operativos_checked = el.active;
        }else if(el.id === 'rate_value'){
            var_tarifa = validateField(el.value);
            var_tarifa = toNumeric(var_tarifa);
        }else if(el.id === 'mp_value'){
            var_primaMinima= validateField(el.value);
            var_primaMinima = toNumeric(var_primaMinima);
        }
    });
}

//Funcion para calcular la Prima del Seguro
function getPrima(fieldInputs, delay = 'false', idImput = '', updatefieldInputs = '', history = '', updateHistory = '') {

 
    /* To Force to updated the Hook */
    if(updatefieldInputs != ''){
        updatefieldInputs((state)=> {
            return state;
        });
    }
 

    // Variables
    let fobField = document.querySelector('#fob_value');
    let rateField = document.querySelector('#rate_value');
    let invalid = false;

    //Valido que el valor Fob y la Tarifa no sean nulos
    fieldInputs.map(el => {
   
        if (el.id === 'fob_value'){
            if(el.value === ''){
                invalid = true;
                addInvalid(fobField, true);
            }else{
                addInvalid(fobField, false);
            }
        }  
        if(el.id === 'rate_value'){
            if (el.value === '') {
                invalid = true;
                addInvalid(rateField, true);
            }else{
                addInvalid(rateField, false);
            }
        }
    });

    addInvalid(body, invalid);

    //Si no es Invalido Comenzamos a calcular la Prima
    if(!invalid){
        let prima = document.querySelector('#prima');

        //Obtengo los valores
        getValues(fieldInputs);

        /* Para tener en cuenta los delay */
        if(delay){
            if(idImput === 'additionalCheck'){
                adicionales_checked = !adicionales_checked;
            }else{
                operativos_checked = !operativos_checked;
            }
        }

        //Subtotal = Valor FOB + Flete + Arancel
        var_subtotal = var_fob + var_flete + var_arancel;
        let subtotal = document.querySelector('#subtotal_result');
        subtotal.innerHTML = formatterDolar.format(var_subtotal);

        // Gastos Adicionales (10%) = Subtotal * 0,1
        var_adicionales = getCheckInputValue('additional_result', adicionales_checked, var_subtotal);

        // Gastos Operativos (10%) = Valor FOB * 0,1
        var_operativos = getCheckInputValue('operatives_result', operativos_checked, var_fob);

        // Valor Asegurado Total = Subtotal + Gastos Adicionales (10%) + Gastos Operativos (10%)
        let aseguradoTotal= document.querySelector('#total_Insured_result');
        var_aseguradoTotal = var_subtotal + var_adicionales + var_operativos;
        aseguradoTotal.innerHTML = formatterDolar.format(var_aseguradoTotal);

        /* Prima o Costo del Certificado de Seguro = 
        Si (Valor Asegurado Total * Tasa) <= Prima Mínima de Venta Entonces la Prima o
            Costo del seguro va a ser igual a la Prima Mínima de Venta.
        Si no, va a ser igual al (Valor Asegurado Total * Tasa).
        */
        let newPrima = '';
        if (var_aseguradoTotal * var_tarifa <= var_primaMinima) {
            newPrima = formatterDolar.format(var_primaMinima);
            prima.innerHTML = newPrima;
        } else {
            newPrima = formatterDolar.format(var_aseguradoTotal * var_tarifa);
            prima.innerHTML =  newPrima;
        }

        /* Por ultimo actualizamos la Hitoria */
        f_updateHistory(history, updateHistory, newPrima)
    }
}

//Funcion para actualizar la historia
function f_updateHistory(history, updateHistory, newPrima) {

    let firstValue = false;
    let counter = 1;
    updateHistory(history.map((el) =>{
        /* Si el ID es igual a Cero entonces confirmo que va hacer el record del historial */
        if(el.id === 0){
            firstValue = true;
        }
        counter++;
    }));

    if(firstValue){
        /* Si el primer valor no reutilizo el contenido */
        updateHistory(  
            [
                {
                    id: 1,
                    value: newPrima
                }
            ]
        );
      
    }else{
        /* Sino reutilizamos el contenido para no perder el historial */
        updateHistory(  
            [
                ...history, {
                    id: counter,
                    value: newPrima
                }
            ]
        );
    }
}

/*** Evento Menu ***/
function menuBar () {
    let btnMenu = document.querySelectorAll('.btnMenu');
    btnMenu.forEach(ele => {
        ele.classList.toggle('opened');
    });
    let leftMenu = document.querySelector('#leftMenu');
    leftMenu.classList.toggle('opened');
}

/*** Evento Menu ***/
function toggleHistory () {
    let btnHistory = document.querySelector('.toggleHistory');
    btnHistory.classList.toggle('opened');

    let historyContainer = document.querySelector('.historyContainer');
    historyContainer.classList.toggle('opened');

    let appWrap = document.querySelector('#root');
    appWrap.classList.toggle('history-active');
}



export {validateField, separador_deMiles, formatterDolar, toNumeric, 
    getCheckInputValue, getPrima, menuBar, toggleHistory};